import { render, staticRenderFns } from "./DialogPlacingOrder.vue?vue&type=template&id=48d46c16&"
import script from "./DialogPlacingOrder.vue?vue&type=script&lang=js&"
export * from "./DialogPlacingOrder.vue?vue&type=script&lang=js&"
import style0 from "./DialogPlacingOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VOverlay,VProgressCircular,VSnackbar})
